import { paperAPI } from '../services/api'
import type { PaperAccountSummary } from '../types'

/**
 * The paper open counts, from the account summary: every open position and
 * every distinct coin. A positions list is a capped page (limit), so its
 * length is never the open count -- 100 and 50 were shown while 187 were open.
 */
export interface PaperOpenCounts {
  open: number
  /** null when the API predates open_coins. */
  coins: number | null
}

export const paperOpenCounts = (account: PaperAccountSummary): PaperOpenCounts => ({
  open: account.open_positions,
  coins: typeof account.open_coins === 'number' ? account.open_coins : null,
})

/** The counts, or null when the account can't be read (shown as "—"). */
export const loadPaperOpenCounts = async (): Promise<PaperOpenCounts | null> => {
  try {
    return paperOpenCounts(await paperAPI.account())
  } catch (error) {
    console.error('Paper account counts failed to load:', error)
    return null
  }
}

export const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`
